import React from 'react';

import { formatDate } from './helpers';


const LastUpdated = ({ lastUpdated }) => {

  return (
    <React.Fragment>
      Last updated: {formatDate(new Date(Date.parse(lastUpdated)))}
    </React.Fragment>
  );
}

export default LastUpdated;
